module.exports = __webpack_public_path__ + "assets/img/36_1499_big.e68ba06c.jpg";